import { createSelector } from 'reselect'

import { STATE_INITIAL, STATE_WITH_GROUPS } from './constants'

const sliceSelector = (state) => state.addUsersToGroup
export const userGroupsLoadingSelector = createSelector(sliceSelector, ({ userGroupsLoading }) => userGroupsLoading)
export const userGroupsSelector = createSelector(sliceSelector, ({ userGroups }) => userGroups)
export const isUserGroupsInitializedSelector = createSelector(sliceSelector, ({ state }) => state !== STATE_INITIAL)
export const hasUserGroupsSelector = createSelector(sliceSelector, ({ state }) => state === STATE_WITH_GROUPS)
export const userGroupsFilterSelector = createSelector(sliceSelector, ({ filter }) => filter)
export const isCompletedSelector = createSelector(sliceSelector, ({ completed }) => completed)
export const userGroupsNextPageSelector = createSelector(sliceSelector, ({ nextPage }) => nextPage)
